import React from 'react';
import { ShareEntityModal } from "../Modals/ShareEntityModal/ShareEntityModal";
import { EditEntityModal } from "../Modals/EditEntityModal";

export const EntityModals = ({
  entity,
  entityType,
  updateEntity,
  showEditModal,
  setShowEditModal,
  showShareModal,
  setShowShareModal,
  onShareSuccess,
}) => {
  return (
    <>
      <EditEntityModal
        entity={entity}
        entityType={entityType}
        updateEntity={updateEntity}
        showModal={showEditModal}
        setShowModal={setShowEditModal}
      />
      <ShareEntityModal
        entityId={entity?.id}
        entityType={entityType}
        showModal={showShareModal}
        setShowModal={setShowShareModal}
        onSuccess={onShareSuccess}
      />
    </>
  );
};
